import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'UnitTasks/'

export const unitTasksService = {
  getAll,

  getAllSm,
  getAllReservedSm,
  getReservedTasksByProductId,

  getAllPm,
  getByIdPm,
  getByIdPmForEdit,

  getAllIum,
  getByIdIum,
  getAllSIum,
  getByIdSIum,

  getAllPrum,
  getByIdPrum,
  getAllSPrum,
  getByIdSPrum,

  getAllCum,
  getAllSCum,

  getByIdCum,
  getByIdSCum,

  getAllClum,
  getAllSClum,

  getByIdClum,
  getByIdSClum,

  getAllWhm,
  getByIdWhm,

  getById,
  add,
  edit,
  delete: _delete,

  cancelTask
}

function getAll() {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllSm(dto) {
  const url = base_url + model + 'getAllSm'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getAllReservedSm(dto) {
  const url = base_url + model + 'getAllReservedSm'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getReservedTasksByProductId(productId) {
  const url = base_url + model + 'getReservedTasksByProductId/' + productId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}

function getAllPm(dto) {
  const url = base_url + model + 'getAllPm'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdPm(id) {
  const url = base_url + model + 'getByIdPm/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getByIdPmForEdit(id) {
  const url = base_url + model + 'getByIdPmForEdit/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllIum(dto) {
  const url = base_url + model + 'getAllIum'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdIum(id) {
  const url = base_url + model + 'GetByIdIum/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllSIum(dto) {
  const url = base_url + model + 'getAllSIum'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdSIum(id) {
  const url = base_url + model + 'getByIdSIum/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}

function getAllPrum(dto) {
  const url = base_url + model + 'getAllPrum'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdPrum(id) {
  const url = base_url + model + 'getByIdPrum/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllSPrum(dto) {
  const url = base_url + model + 'getAllSPrum'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdSPrum(id) {
  const url = base_url + model + 'getByIdSPrum/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeaderJson() })
}

function getAllCum(dto) {
  const url = base_url + model + 'getAllCum'
  console.log(url)
  console.log(dto)

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getAllSCum(dto) {
  const url = base_url + model + 'getAllSCum'
  console.log(dto)

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdCum(id) {
  const url = base_url + model + 'GetByIdCum/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getByIdSCum(id) {
  const url = base_url + model + 'GetByIdSCum/' + id
  console.log(url)

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllClum(dto) {
  const url = base_url + model + 'getAllClum'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getAllSClum(dto) {
  const url = base_url + model + 'getAllSClum'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdClum(id) {
  const url = base_url + model + 'GetByIdClum/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getByIdSClum(id) {
  const url = base_url + model + 'GetByIdSClum/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllWhm(dto) {
  const url = base_url + model + 'getAllWhm'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getByIdWhm(id) {
  const url = base_url + model + 'getByIdWhm/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getById(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(form) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, form, { headers: authHeaderJson() })
}

function edit(id, form) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, form, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}

function cancelTask(id) {
  const url = base_url + model + 'cancelTask/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}
